// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import 'es6-object-assign/auto'
import App from './App'
import AppFooter from '@/views/components/AppFooter'
import AppNavigation from '@/views/components/AppNavigation'
import CardClaimForms from '@/views/components/cards/ClaimForms'
import CardClaimsApprover from '@/views/components/cards/ClaimsApprover'
import CardClaimsSubmitter from '@/views/components/cards/ClaimsSubmitter'
import CardContent from '@/views/components/cards/Content'
import CardDynamicContent from '@/views/components/cards/DynamicContent'
import CardLeaderboard from '@/views/components/cards/Leaderboard'
import CardQuizzes from '@/views/components/cards/Quizzes'
import CardReport from '@/views/components/cards/Report'
import CardTarget from '@/views/components/cards/Target'
import CardTier from '@/views/components/cards/Tier'
import ChartCard from '@/views/components/cards/Chart'
import LoadingIcon from '@/views/components/LoadingIcon'
import MultiCard from '@/views/components/cards/MultiCard'
import PortalVue from 'portal-vue'
import router from './router'
import store from './store'
import Vue from 'vue'
import i18n from './resources/lang'

Vue.config.productionTip = false
Vue.config.devtools = process.env.APP_DEBUG === true
Vue.config.performance = process.env.APP_DEBUG === true

Vue.component('app-navigation', AppNavigation)
Vue.component('app-footer', AppFooter)
Vue.component('loading-icon', LoadingIcon)
Vue.component('card-claim-forms', CardClaimForms)
Vue.component('card-claims-approver', CardClaimsApprover)
Vue.component('card-claims-submitter', CardClaimsSubmitter)
Vue.component('card-content', CardContent)
Vue.component('card-dynamic-content', CardDynamicContent)
Vue.component('card-target', CardTarget)
Vue.component('card-leaderboard', CardLeaderboard)
Vue.component('card-quizzes', CardQuizzes)
Vue.component('card-tier', CardTier)
Vue.component('card-report', CardReport)
Vue.component('card-multi-card', MultiCard)
Vue.component('card-chart', ChartCard)

Vue.use(PortalVue)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js